module.exports = "/virtual-football-league/img/amblems/left/Germany/Fake_Hertha.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/Germany/Fake_Hertha.png
// module id = 2036
// module chunks = 4